import { render, staticRenderFns } from "./news-detail.vue?vue&type=template&id=7c08e896&scoped=true"
import script from "./news-detail.vue?vue&type=script&lang=js"
export * from "./news-detail.vue?vue&type=script&lang=js"
import style0 from "./news-detail.vue?vue&type=style&index=0&id=7c08e896&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08e896",
  null
  
)

export default component.exports